import { Helmet } from "react-helmet-async";

import { useBrandColorContext } from "@/contexts/BrandColorContext";

const DEFAULT_FAVICON = "/favicon.svg";

export const BrandFavicon = () => {
  const { favicon } = useBrandColorContext();
  const faviconHref = favicon ?? DEFAULT_FAVICON;

  return (
    <Helmet>
      <link rel="icon" href={faviconHref} />
    </Helmet>
  );
};
